import userApi from './user/api'
import vendorApi from './vendor/api'

const ok = (data = {}) => Promise.resolve({ status: true, data })

const api = {
  ...userApi,
  ...vendorApi,
  getProfileApi(formData) {
    return userApi.getProfile(formData)
  },
  getBusinessDetail(formData) {
    return userApi.getVendorDetail(formData)
  },
  async getInvitations() {
    return ok({ status: 'ok', data: [], upcomingdata: [], olddata: [], draftdata: [] })
  },
  async getReceivedInvitations() {
    return ok({ status: 'ok', list: [], list_upcoming: [], list_old: [], list_draft: [] })
  },
  async deleteInvitation() {
    return ok({ status: 'ok' })
  },
  async moreApps() {
    return ok({ status: 'ok', data: [] })
  },
  async getAlbums() {
    return ok({ status: 'ok', data: [] })
  },
  async getReceivedAlbums() {
    return ok({ status: 'ok', list: [] })
  },
  async getEnquiries() {
    return ok({ status: 'ok', list: [] })
  },
  async getInviteEnquiryDetails() {
    return ok({ status: 'ok', data: [] })
  },
  async getMyContacts() {
    return ok({ status: 'ok', data: [] })
  },
  async getMyFriends() {
    return ok({ status: 'ok', data: [] })
  },
  async searchUsersInfo() {
    return ok({ status: 'ok', data: [] })
  },
  async sendRequestContact() {
    return ok({ status: 'ok' })
  },
  async approveRequest() {
    return ok({ status: 'ok' })
  },
  async cancelRequest() {
    return ok({ status: 'ok' })
  },
  async updateProfile() {
    return ok({ status: 'ok', message: 'Profile updated' })
  },
  async changePassword() {
    return ok({ status: 'ok', message: 'Password updated' })
  },
  async getEventTypes() {
    return ok({ status: 'ok', data: [], list: [] })
  },
  async getInvitationDetail() {
    return ok({ status: 'ok', data: {}, list: [] })
  },
  async getInviteModules() {
    return ok({ status: 'ok', data: [], list: [] })
  },
  async CreateInvitation() {
    return ok({ status: 'ok', data: {}, message: 'Invitation created' })
  },
  async editInvitation() {
    return ok({ status: 'ok', data: {}, message: 'Invitation updated' })
  },
  async getNotesMembersEventDetail() {
    return ok({ status: 'ok', data: [], list: [] })
  },
  async getReceivedInvitationDetail() {
    return ok({ status: 'ok', data: {} })
  },
  async getConnectionsStats() {
    return ok({ status: 'ok', data: {} })
  },
  async getConnections() {
    return ok({ status: 'ok', data: [], list: [] })
  },
  async getConnectionsEvents() {
    return ok({ status: 'ok', data: [], list: [] })
  },
  async getHiredVendors() {
    return ok({ status: 'ok', data: [] })
  },
  async getNearByVendors() {
    return ok({ status: 'ok', data: [] })
  },
  async addHiredVendors() {
    return ok({ status: 'ok' })
  },
  async updateHiredVendors() {
    return ok({ status: 'ok' })
  },
  async deleteHiredVendors() {
    return ok({ status: 'ok' })
  },
  async getEventPosts() {
    return ok({ status: 'ok', data: [] })
  },
  async addEventPost() {
    return ok({ status: 'ok' })
  },
  async deleteEventPost() {
    return ok({ status: 'ok' })
  },
  async likeEventPost() {
    return ok({ status: 'ok' })
  },
  async getEventPostVotes() {
    return ok({ status: 'ok', data: [] })
  },
  async updatePollEventPost() {
    return ok({ status: 'ok' })
  },
  async getEventPostComments() {
    return ok({ status: 'ok', data: [] })
  },
  async addEventPostComment() {
    return ok({ status: 'ok' })
  },
  async getReceivedInvitationsProfile() {
    return ok({ status: 'ok', list: [], list_upcoming: [], list_old: [], list_draft: [] })
  }
}

export default api
